import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import errorBoundary from '@ifeng/errorBoundary';
import Title from './title';
import ContentTitle from '../../../../components/contentTitle';
import PicList from '../../../../components/picList';
import NewsList from '../../../../components/newsList';

class VideoBox extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: {
                videoTitle,
                videoContent0,
                videoContent1,
                videoContent2,
                videoWSContent,
                videoJSContent,
                videoLSContent,
                videoWHContent,
                videoCJContent,
                videoKJContent,
                videoPEContent,
                videoFFHContent,
                videoGGContent,
                videoListAd,
            },
        } = this.props;

        return (
            <div id="newsVideoList" className={styles.video_box}>
                <Chip id="230036" type="struct" title="要闻区右栏视频标题" groupName="要闻区右栏" content={videoTitle}>
                    <Title />
                </Chip>
                <Chip
                    id="75031"
                    type="recommend"
                    title="要闻区右栏视频区图文编辑1_视频"
                    groupName="要闻区右栏"
                    translate="handleNewsVideoContentData"
                    translateOptions={{ index: 1 }}
                    content={videoContent0}>
                    <PicList hasTopic isVideo />
                </Chip>
                <Chip
                    id="75032"
                    type="recommend"
                    title="要闻区右栏视频区图文编辑2_娱乐"
                    groupName="要闻区右栏"
                    translate="handleNewsVideoContentData"
                    translateOptions={{ index: 0 }}
                    content={videoContent1}>
                    <PicList isVideo />
                </Chip>
                <Chip
                    id="75033"
                    type="recommend"
                    title="要闻区右栏视频区图文编辑3_时尚"
                    groupName="要闻区右栏"
                    translate="handleNewsVideoContentData"
                    translateOptions={{ index: 0 }}
                    content={videoContent2}>
                    <PicList isVideo />
                </Chip>
                <div className={styles.video_list}>
                    <Chip
                        id="75034"
                        type="recommend"
                        title="要闻区右栏视频区新闻列表_视频"
                        groupName="要闻区右栏"
                        translate="handleVideoContentData1"
                        content={videoWSContent}>
                        <NewsList />
                    </Chip>
                    <Chip
                        id="75035"
                        type="recommend"
                        title="要闻区右栏视频区新闻列表_军事"
                        groupName="要闻区右栏"
                        translate="handleVideoContentData1"
                        content={videoJSContent}>
                        <NewsList />
                    </Chip>
                    <Chip
                        id="75036"
                        type="recommend"
                        title="要闻区右栏视频区新闻列表_历史"
                        groupName="要闻区右栏"
                        translate="handleVideoContentData1"
                        content={videoLSContent}>
                        <NewsList />
                    </Chip>
                    <Chip
                        id="75037"
                        type="recommend"
                        title="要闻区右栏视频区新闻列表_文化"
                        groupName="要闻区右栏"
                        translate="handleVideoContentData1"
                        content={videoWHContent}>
                        <NewsList />
                    </Chip>
                    <Chip
                        id="75038"
                        type="recommend"
                        title="要闻区右栏视频区新闻列表_财经"
                        groupName="要闻区右栏"
                        translate="handleVideoContentData1"
                        content={videoCJContent}>
                        <NewsList />
                    </Chip>
                    <Chip
                        id="75039"
                        type="recommend"
                        title="要闻区右栏视频区新闻列表_科技"
                        groupName="要闻区右栏"
                        translate="handleVideoContentData1"
                        content={videoKJContent}>
                        <NewsList />
                    </Chip>
                    <Chip
                        id="75040"
                        type="recommend"
                        title="要闻区右栏视频区新闻列表_体育"
                        groupName="要闻区右栏"
                        translate="handleVideoContentData1"
                        content={videoPEContent}>
                        <NewsList />
                    </Chip>
                    <Chip
                        id="75041"
                        type="recommend"
                        title="要闻区右栏视频区新闻列表_大风号"
                        groupName="要闻区右栏"
                        translate="handleVideoContentData1"
                        content={videoFFHContent}>
                        <NewsList />
                    </Chip>
                    <Chip
                        id="75042"
                        type="recommend"
                        title="要闻区右栏视频区新闻列表_游戏"
                        groupName="要闻区右栏"
                        translate="handleVideoContentData1"
                        content={videoGGContent}>
                        <NewsList ad={videoListAd} />
                    </Chip>
                </div>
            </div>
        );
    }
}

export default errorBoundary(VideoBox);
